import calc from 'calculatorjs'
export function coverItemUrl (itemUrl) {
  return itemUrl?.replace('https://', 'taobao://')
}

export function getRebateCoinAmount (maxCommissionRate, price) {
  return Math.floor(calc(`${maxCommissionRate} / 100 * ${price}* 0.5 * 4.5 * 10`))
  // 佣金 * 0.5 * 4.5 * 10
}
